let leftdata = [
  {
    source: {
      id: "the-wall-street-journal",
      name: "The Wall Street Journal",
    },
    author: "Belle Lin",
    title: "CIO 2023 Priorities: Cybersecurity - The Wall Street Journal",
    description: "CIO 2023 Priorities: Cybersecurity  The Wall Street Journal",
    url: "https://www.wsj.com/articles/cio-2023-priorities-cybersecurity-11672259635",
    urlToImage: "https://images.wsj.net/im-691043/social",
    publishedAt: "2022-12-30T12:00:00Z",
    content:
      "Technology executives in a recent CIO Journal end-of-year survey shared their priorities for 2023. While recruiting and retaining talent and leading through a tightening economy topped many to-dos, t… [+3171 chars]",
  },
  {
    source: {
      id: "the-wall-street-journal",
      name: "The Wall Street Journal",
    },
    author: "Meghan Bobrowsky",
    title:
      "Tesla Stock Is Headed for Its Biggest-Ever Annual Decline - The Wall Street Journal",
    description:
      "<ol><li>Tesla Stock Is Headed for Its Biggest-Ever Annual Decline  The Wall Street Journal\r\n</li><li>The vibes are off at Tesla  The Verge\r\n</li><li>Retail Investors and Hedge Funds Show Faith in Tesla (NASDAQ:TSLA) Stock  TipRanks\r\n</li><li>Elon Musk's compa…",
    url: "https://www.wsj.com/articles/tesla-stock-is-headed-for-its-biggest-ever-annual-decline-11672374248",
    urlToImage: "https://images.wsj.net/im-694429/social",
    publishedAt: "2022-12-30T10:30:00Z",
    content:
      "Tesla Inc. is poised Friday to close the worst year in the stocks history, having lost more than $700 billion in market valuation amid investor concerns about production disruptions, demand worries a… [+475 chars]",
  },
  {
    source: {
      id: "the-wall-street-journal",
      name: "The Wall Street Journal",
    },
    author: "Douglas Belkin",
    title:
      "The Impossible Decisions That Faced Those Trapped in the Buffalo Blizzard - The Wall Street Journal",
    description:
      "<ol><li>The Impossible Decisions That Faced Those Trapped in the Buffalo Blizzard  The Wall Street Journal\r\n</li><li>A Buffalo woman went out on Christmas Eve, telling her daughter she'd be right back. They found her body a few hundred feet from home  CNN\r\n</…",
    url: "https://www.wsj.com/articles/the-impossible-decisions-that-faced-those-trapped-in-the-buffalo-storm-11672318815",
    urlToImage: "https://images.wsj.net/im-693591/social",
    publishedAt: "2022-12-29T22:06:00Z",
    content:
      "On Friday afternoon, Abdul Sharifu left his house in Buffalo, N.Y., to go to the market to buy milk for his two young children. He hadnt gotten far when his car got stuck \r\nin one of the deadliest bl… [+451 chars]",
  },
  {
    source: {
      id: "the-wall-street-journal",
      name: "The Wall Street Journal",
    },
    author: "Liz Essley Whyte",
    title:
      "FDA Faulted for Working Improperly With Biogen Before Clearing Alzheimer’s Drug",
    description:
      "Aduhelm approval followed ‘atypical’ agency contacts with company, congressional report says",
    url: "https://www.wsj.com/articles/biogen-aduhelm-fda-approval-congressional-investigation-11672333482",
    urlToImage: "https://images.wsj.net/im-692208/social",
    publishedAt: "2022-12-29T18:00:00Z",
    content:
      "The U.S. Food and Drug Administration inappropriately collaborated with Biogen Inc. before approving its Alzheimers treatment Aduhelm in 2021, a new report from House Democrats concluded, as the agen… [+264 chars]",
  },
  {
    source: {
      id: "the-wall-street-journal",
      name: "The Wall Street Journal",
    },
    author: "Asa Fitch",
    title: "半導体不足が一転、供給過剰　PC・スマホ低迷で",
    description:
      "世界は今、半導体チップであふれている。 チップは2年間の旺盛な需要による世界的な不足から一転、供給過剰に陥っている。金利上昇や株価下落、リセッション（景気後退）懸念を受け、電子機器製品に対する消費者需要は減退している。チップ在庫の膨張は、より広範な経済の現状を反映している。小売業者は棚に商品があふ...",
    url: "https://jp.wsj.com/articles/chip-inventories-swell-as-consumers-buy-fewer-gadgets-11672206934",
    urlToImage: "https://images.wsj.net/im-692137/social",
    publishedAt: "2022-12-29T15:15:18Z",
    content:
      "2\r\n1\r\nCEO21202319-1110\r\nUBS1040\r\n2HP\r\nHPCEO2\r\n1211\r\nCEO10CPUAMD\r\nAMDCEO\r\nCFO11202211-20231\r\n202392023\r\n203\r\n11CFO23\r\n2030211341000\r\nCPU\r\n3101129CEO\r\n1520\r\nCopyright ©2022 Dow Jones &amp; Company, Inc… [+54 chars]",
  },
];


export default leftdata;
